import * as MUTATIONS from './mutations';

const getters = {};

const state = {
  slugsToExportHistoric: [],
  initialDate: '',
  finalDate: '',
  removeStandby: false,
  formatationFile: '',
  fileType: '',
};

const actions = {};

const mutations = {
  [MUTATIONS.SET_SLUGS_TO_EXPORT_HISTORIC]: (state, value) => (state.slugsToExportHistoric = value),
  [MUTATIONS.SET_INITIAL_DATE]: (state, value) => (state.initialDate = value),
  [MUTATIONS.SET_FINAL_DATE]: (state, value) => (state.finalDate = value),
  [MUTATIONS.SET_REMOVE_STANBDY]: (state, value) => (state.removeStandby = value),
  [MUTATIONS.SET_FORMATATION_FILE]: (state, value) => (state.formatationFile = value),
  [MUTATIONS.SET_FILE_TYPE]: (state, value) => (state.fileType = value),
};

export default {
  getters,
  state,
  actions,
  mutations,
};
